import { SidebarPage, CategoryList, ListItem } from "./styles";

import Layout from "../Layout";
import Container from "../Container";
import CategoriesList from "../CategoriesList";
import NoImageList from "../NoImageList";
import OriginList from "../OriginList";
import OutletList from "../OutletList";
import { useUser } from "../UserContext";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";



export default ({ children, token, loadScreen }) => {
  // export default ({ address, setAddress, changeState, cities }) => (

  async function add_products_to_cart()
  {
    
    const newCart = await cartApi.itensFromCategories({ user_token: token, cart_token, id: categorySlug, parent_id: subcategorySlug, page: 99999 });
    setCart(newCart);

  }
  
  // debugger;
  async function generateLoading(isLoading) {
    return loadScreen(isLoading);
  }
  const { user } = useUser();

  return (
    <Layout token={token}>
      <Container>
        <SidebarPage>
         
        <div class="wrapper">   
        <div id="container-origin">
          <div class="parent">Origem</div>
          <CategoryList>
              <OriginList loadScreen={generateLoading}/>
          </CategoryList>
        </div>    
        <div id="container-outlet">
          <div class="parent">Outlet</div>
          <CategoryList>
              <OutletList loadScreen={generateLoading}/>
          </CategoryList>
        </div>  
          <div id="container">
            <div class="parent">Categorias</div>
            <CategoryList>
              <CategoriesList />
            </CategoryList>
          </div>
            {/* <a rel="noopener noreferrer" title="Feira" href="https://m.goodsbr.com.br/cadastro-goods-show">
              <LazyLoadImage
                effect="blur"
                src="/show-lateral.jpg"
                alt="Banner"
                style={{ margin: "0 auto", display: "block" }}
              />
            </a> */}
        </div>
 
          {children}
          
        </SidebarPage>
      </Container>
    </Layout>
  );
}

